import { TFunction } from "i18next";
import * as yup from "yup";

import { QualificationType } from "./QualificationType";

export interface ProgramNameValidationSchemeProps {
  t: TFunction;
}

export const ProgramNameValidationScheme = ({
  t,
}: ProgramNameValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
    name: yup.string().required(requiredMsg),
    programTypeId: yup.number().nullable().required(requiredMsg).min(1, requiredMsg),
    hkoLevelId: yup.number().nullable().required(requiredMsg).min(1, requiredMsg),
    qualificationTypeId: yup.number().nullable().required(requiredMsg).min(1, requiredMsg),
    educationSectorId: yup.number().nullable().required(requiredMsg).min(1, requiredMsg),
    educationSubSectorId: yup.number().when("qualificationTypeId", {
      is: QualificationType.MicroQualification,
      then: yup.number().nullable(),
      otherwise: yup.number().nullable().required(requiredMsg).min(1, requiredMsg) 
    }),
  });;
};